import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface PProps extends HTMLAttributes<HTMLParagraphElement> {}

const P = forwardRef<HTMLParagraphElement, PProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn('leading-7 [&:not(:first-child)]:mt-6', className)}
        {...props}
      >
        {children}
      </p>
    );
  }
);

P.displayName = 'P';

export { P };
